import ClassicInvitation from "./classic/ClassicInvitation";

/**
 * The component that draws each template in registry.js, by template id —
 * one for every TEMPLATES entry. Adding a template = its entry in the three
 * registries + its folder here + a row below (INVITATION-EDITOR-SPEC.md §2).
 */
export const TEMPLATE_COMPONENTS = Object.freeze({
  classic: ClassicInvitation,
});
